import { render, staticRenderFns } from "./steelDefects.vue?vue&type=template&id=3e7e5861&scoped=true&"
import script from "./steelDefects.vue?vue&type=script&lang=js&"
export * from "./steelDefects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7e5861",
  null
  
)

export default component.exports